import React, {useState, useEffect, useRef} from 'react';
import {NavLink, useNavigate, useSearchParams} from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";

import styles from './Login.module.scss';
import CTABackground from "../../assets/images/login_main_container_v2.png"
import Logo from "../../assets/images/shishi_logo.png"

import ButtonMain from "../../components/buttons/ButtonMain/ButtonMain";
import {CONFIG_LOGIN, ENV} from "../../shared/constants";
import FindId from "../FindId/FindId";
import Loading from "../../components/Loading/Loading";
import PopupInfo from "../../components/PopupInfo/PopupInfo";
import {logUserIn} from "../../redux/rootReducer";
import withRequestHandler from "../../HOC/withRequestHandler";

const INPUT_REQUIRE_LENGTH_ID = 16;
const INPUT_REQUIRE_LENGTH_NAME = 20;

const Login = ({ setPlayer, config, isLoading, makeRequest, logout }) => {
    let isFirstPageView = useRef(true);
    const { isLogged, error } = useSelector((state) => state.rootReducer);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [inputValueId, setInputValueId] = useState('');
    const [inputValueName, setInputValueName] = useState('');
    const [hasLoginError, setHasLoginError] = useState(false);
    const [errorLoginMessage, setErrorLoginMessage] = useState('');

    const onChangeId = (val) => {
        let id = val.trim();
        id = id.replace(/[^0-9]/g, '');
        if (INPUT_REQUIRE_LENGTH_ID) {
            id = id.slice(0, INPUT_REQUIRE_LENGTH_ID);
        }
        setInputValueId(id);
    }

    const onChangeName = (val) => {
        let name = val.trim();
        if (INPUT_REQUIRE_LENGTH_NAME) {
            name = name.slice(0, INPUT_REQUIRE_LENGTH_NAME);
        }
        setInputValueName(name);
    }

    const verifyAgeAndSendId = () => {
        if (!inputValueId.length) {
            setHasLoginError(true);
            setErrorLoginMessage('EMPTY_INPUT_ID');
            return;
        }
        if (!inputValueName.length) {
            setHasLoginError(true);
            setErrorLoginMessage('EMPTY_INPUT_NAME');
            return;
        }
        logTheUser();
    }

    const logTheUser = async (username, userId) => {
        let pId = userId || inputValueId;
        let pName = username || inputValueName;

        const playerInfo = {username: pName, userId: pId};
        const data = await makeRequest('post','login', {...playerInfo});
        if (data && data.success) {
            setInputValueId('');
            setInputValueName('');
            localStorage.setItem('shishiPlayerInfo', JSON.stringify(playerInfo));
            dispatch(logUserIn());
            setPlayer(playerInfo);
            navigate('/shop');
        }
    }

    useEffect(() => {
        let player = localStorage.getItem('shishiFreeGiftPlayerInfo');
        player = JSON.parse(player);
        const pId = searchParams.get('pid');
        const pName = decodeURIComponent(searchParams.get('pname'));

        if ((pId && pId.length)
            && (pName && pName.length)
        ) {
            if (player && player.username && player.userId) {
                logout(pId, pName);
            } else {
                onChangeId(pId);
                onChangeName(pName);
            }
        }

    }, [searchParams]);

    useEffect(() => {
        const pId = searchParams.get('pid');
        const pName = decodeURIComponent(searchParams.get('pname'));

        if (pId && pName) {
            logout(pId, pName);
            logTheUser(pName, pId);
        }

    }, [searchParams]);

    useEffect(() => {
        let player = localStorage.getItem('shishiPlayerInfo');
        player = JSON.parse(player);

        if (isLogged || (player && player.username && player.userId)) {
            navigate('/shop');
        }
    }, [isLogged]);

    useEffect(() => {
        if (isFirstPageView.current) {
            window.gtag('event', 'screen_view', {
                'app_name': 'Shishi shop',
                'screen_name': 'page_login'
            });
            window.gtag('event', 'page_view', {
                'app_name': 'Shishi shop',
                'page_title': 'login'
            });
            isFirstPageView.current = false;
        }
    }, []);

    return (
        <div className={styles.loginWrapper}>
            {CONFIG_LOGIN.hasInfoText ?
                <div className={styles.infoText}>
                    {config.loginInfo}
                </div>
                :
                null
            }
            <img src={Logo} className={styles.logo} alt={''} />
            <div className={styles.ctaWrapper}>
                <img src={CTABackground} className={styles.ctaBackground} alt={''} />
                <div className={styles.loginTitle}>{config.headerTitle}</div>
                <div className={styles.enterIdText}>{config.signWithId}</div>
                <div className={styles.inputWrapper}>
                    <input
                        placeholder={config.idPlaceHolder}
                        onFocus={() => hasLoginError ? setHasLoginError(false) : null}
                        onChange={(e) => {
                            const val = (e.target.value);
                            onChangeId(val);
                        }}
                        value={inputValueId}
                    />
                </div>
                {CONFIG_LOGIN.hasUsernameConfirm ?
                    <>
                        <div className={styles.enterName}>{config.singWithName}</div>
                        <div className={styles.inputWrapper}>
                            <input
                                placeholder={config.namePlaceHolder}
                                onFocus={() => hasLoginError ? setHasLoginError(false) : null}
                                onChange={(e) => {
                                    const val = (e.target.value);
                                    onChangeName(val);
                                }}
                                value={inputValueName}
                            />
                        </div>
                    </>
                    :
                    null
                }
                <div className={styles.errMessage}>{hasLoginError ? config.errors[errorLoginMessage] : null}</div>
                <ButtonMain text={config.proceed} onClick={verifyAgeAndSendId} />
            </div>
            {CONFIG_LOGIN.isFindIdLink ?
                <NavLink to={'find-id'} className={styles.troubleShoot}>{config.problemFindingId}</NavLink>
                :
                <div className={styles.filnIdWrapper}>
                    <FindId config={config} />
                </div>
            }
            {isLoading ? <Loading withOverlay={true} /> : null}
            {error.hasError ? <PopupInfo text={error.message} /> : null}
        </div>
    );
};

export default withRequestHandler(Login);